import { MultiSelectOption } from "@/components/ui/multi-select-checkbox";

export interface ContestOption {
  id: number;
  name: string;
}

export interface UnityOption {
  id: number;
  name: string;
}

export interface SellerOption {
  id: number;
  unity_id?: number;
  user?: { id: number; name: string };
  unity?: { id: number; name: string };
}

export interface ProductOption {
  id: number;
  contest_id: number;
  product_name: string;
  contest_name?: string | null;
}

export interface ReferenceDataProps {
  contests: ContestOption[];
  unities: UnityOption[];
}

export const toOptions = (
  items: { id: number; name: string }[]
): MultiSelectOption[] =>
  items.map((item) => ({ value: String(item.id), label: item.name }));

/**
 * Bolões podem ter o mesmo nome (B1, B2...) em concursos diferentes,
 * por isso o rótulo inclui o concurso quando disponível.
 */
export const toProductOptions = (
  products: ProductOption[],
  showContest: boolean
): MultiSelectOption[] =>
  products.map((product) => ({
    value: String(product.id),
    label:
      showContest && product.contest_name
        ? `${product.contest_name} — ${product.product_name}`
        : product.product_name,
  }));

export const toSellerOptions = (sellers: SellerOption[]): MultiSelectOption[] =>
  sellers.map((seller) => ({
    value: String(seller.id),
    label: seller.user?.name ?? `Vendedor #${seller.id}`,
  }));

/**
 * Remove da seleção os valores que não existem mais nas opções.
 *
 * Devolve a MESMA referência quando nada muda - `array.filter()` sempre cria um
 * novo array, e uma nova referência no state dispara re-render e, por
 * consequência, uma segunda requisição de listagem.
 */
export const pruneSelection = (current: string[], allowed: Set<string>): string[] => {
  const next = current.filter((value) => allowed.has(value));

  return next.length === current.length ? current : next;
};
